import { useEffect, useState } from 'react';
import { useAppConstantsContext } from '@/context/AppConstants';
import { Modal, styled } from '@/theme/index';
import { Chapter } from './Chapter/Chapter';
import { PictureBookChapter } from './interface';

interface PictureBookModalProps {
  open: boolean;
  handleCloseModal: () => void;
}

const StyledModal = styled(Modal)(({ theme }) => ({
  '.MuiDialog-paper': {
    width: '100%',
    height: '100%',
    borderRadius: '4px',
    margin: theme.spacing(2),

    [theme.breakpoints.up('sm')]: {
      maxWidth: '900px',
      height: 'auto',
      width: '100%',
      margin: theme.spacing(2),
    },
  },
  '.MuiDialogContent-root': {
    padding: 0,
  },
}));

export const PictureBookModal = ({
  open,
  handleCloseModal,
}: PictureBookModalProps) => {
  const {
    data: { vehiclePictureBook },
  } = useAppConstantsContext();

  const [chapters, setChapters] =
    useState<typeof vehiclePictureBook>(vehiclePictureBook);
  const [currentScreenIndex, setCurrentScreenIndex] = useState(0);
  const [currentScreenData, setCurrentScreenData] =
    useState<PictureBookChapter | null>(null);

  useEffect(() => {
    if ((chapters ?? []).length === 0) {
      setChapters(vehiclePictureBook!);
    }

    setCurrentScreenData(chapters?.[currentScreenIndex] ?? null);
  }, [chapters, currentScreenIndex, vehiclePictureBook]);

  const resetState = () => {
    setCurrentScreenData(null);
    setCurrentScreenIndex(0);
  };

  const next = () => {
    if (currentScreenIndex < (chapters?.length ?? 0) - 1) {
      setCurrentScreenIndex((prevIndex) => prevIndex + 1);
    }
  };

  const previous = () => {
    if (currentScreenIndex > 0) {
      setCurrentScreenIndex((prevIndex) => prevIndex - 1);
    }
  };

  const exitModal = () => {
    resetState();
    handleCloseModal();
  };

  const close = () => {
    exitModal();
  };

  const handleCloseOutsideModal = () => {
    exitModal();
  };

  const actionHandlers = {
    next,
    previous,
    close,
    exitModal,
  };

  return (
    <StyledModal
      open={open}
      onClose={handleCloseOutsideModal}
      data-testid="story-book-modal"
    >
      {currentScreenData && (
        <Chapter
          currentScreenData={currentScreenData}
          actionHandlers={actionHandlers}
          currentScreenIndex={currentScreenIndex}
        />
      )}
    </StyledModal>
  );
};
